import { Box, Button, TextField } from '@mui/material';
import { BoxFC, BoxFR } from 'components/BoxCustom';
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand';
import React, { useCallback, useState, useContext, useEffect, useMemo } from 'react';
import { columns } from './columns';
import { GlobalStateContext } from 'contexts/GlobalStateContext';
import SearchButton from 'components/buttons/SearchButton';
import ClearButton from 'components/buttons/ClearButton';
import { initFilterData, clearFilterData } from './initData';
import { addIdForDataGrid, numberFormat } from 'utils';
import { branchApiNm } from 'branch/constant/branchApiNm';
import { PrintRounded } from '@mui/icons-material';
import { printFuelReportPeriod } from './printFuelReportPeriod';
import { DesktopDatePicker } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';
import FuelDialog from 'pages/Menu1/FuelManagement/FuelDialog';
import { fuelApiNm } from 'constants/FuelConstatn';

let fuelId = null

const FuelReportPeriod = () => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [dialogOpen, setDialogOpen] = useState(false)
  const [fuelMaster, setFuelMaster] = useState({ fuelStnCombo: [], fuelFileTypeCombo: [] })


  const monthPickerProp = useMemo(() => ({
    openTo: "month",
    views: ["year", "month"],
    disableMaskedInput: true,
    label: "เดือน-ปี",
    inputFormat: "MMMM YYYY",
    value: filterData.SalDte,
    onChange: (newValue) => { setFilterData(o => ({ ...o, SalDte: newValue })) },
    renderInput: (params) => <TextField size="small" {...params} sx={{ width: 200 }} />,

  }), [filterData.SalDte])

  const getData = useCallback((filter) => {
    const postData = {
      FuelTmSt: dayjs(filter.SalDte).add(-1, 'month').format("YYYY-MM-26 00:00:00"),
      FuelTmEn: dayjs(filter.SalDte).format("YYYY-MM-25 23:59:59"),
      SalDte: dayjs(filter.SalDte).format("YYYY-MM-01 00:00:00"),
    }
    ax.post(branchApiNm.getFuelPeriodReport, postData).then(value => {
      if (value.data) {
        const result = value.data

        for (const row of result) {
          row.FuelTmSt = postData.FuelTmSt
          row.FuelTmEn = postData.FuelTmEn
          let col = 0
          for (const litr of row.Litrs) {
            col++
            row[`Litr${col}`] = numberFormat(litr)
          }
          row.Rate = row.TotalLitr === 0 ? 0 : (row.MileTukDiff / row.TotalLitr).toFixed(2)


          if (row.NumJo) {
            const numJos = row.NumJo.split(",")
            // console.log("numJos::", numJos)
            let nums = []
            for (const numJo of numJos) {
              const numAndJo = numJo.split(":")
              if (numAndJo.length === 2) {
                nums.push(numAndJo[1])
              }
            }
            row.NumJo = nums.join(", ")
          }
        }
        setDataTable(addIdForDataGrid(value.data, "Id"))
        setFilterData(postData)
      }
    })
  }, [ax])

  const handlePrint = useCallback(() => {
    const dataColumns = columns.map(col => ({ ...col }))
    dataColumns.splice(3, 2)
    printFuelReportPeriod({ msData, dataTable, columns: dataColumns, dteSt: filterData.FuelTmSt, dteEn: filterData.FuelTmEn })
  }, [filterData.FuelTmSt, filterData.FuelTmEn, dataTable, msData])

  const handleCellClick = useCallback(({field, row, value}) => {
    if(field.startsWith('Litr') && value){
      console.log("row::", row)
      const indexStr = field.replace('Litr', '')
      const index = parseInt(indexStr)
      if(row.FuelIds[index-1]){
        fuelId = row.FuelIds[index-1]
        setDialogOpen(true)
      }
    }
  }, [])

  useEffect(() => {
    getData({ ...initFilterData })
  }, [getData])

  useEffect(() => {
    ax.post(fuelApiNm.getMasterFuel).then(value => {
      if (value.data) {
        setFuelMaster({
          fuelStnCombo: value.data.fuelStns.map(item => ({ id: item.FuelStnId, label: item.FuelStnCd, IsCalMile: item.IsCalMile })),
          fuelFileTypeCombo: value.data.fuelFileTypes.map(item => ({ id: item.FuelFileTypId, label: item.Name }))
        })
        // setFuleFileTypeCombo(value.data.fuelFileTypes.map(item=>({id: item.FuelFileTypId, name: item.Name})))
        // setFuelStnCombo(value.data.fuelStns.map(item=>({id: item.FuelStnId, name: item.FuelStnCd})))
      }
    })
  }, [ax])
  return (
    <BoxFC height='100%'>
      <BoxFR>
        <Button variant="contained" onClick={handlePrint}><PrintRounded sx={{ mr: 1 }} /> พิมพ์</Button>
        <Box flex={1} />

        <DesktopDatePicker {...monthPickerProp} />
        {/* <DateTimeSelect sx={{ width: 180 }} label='เวลาเติมน้ำมัน' start={filterData.FuelTmSt} end={filterData.FuelTmEn}
          setSelectDate={(st, en) => { setFilterData(o => ({ ...o, FuelTmSt: st, FuelTmEn: en })) }}
          getData={() => { getData(filterData) }}
        /> */}
        <SearchButton onClick={(() => getData(filterData))} />
        <ClearButton onClick={(() => setFilterData({ ...clearFilterData }))} />
      </BoxFR>
      <Box height='100%' >
        <DataGridCellExpand
          disableSelectionOnClick={false}
          hideFooter
          onCellClick={handleCellClick}
          rows={dataTable}
          columns={columns}
          initialState={{
            pinnedColumns: {
              left: ['No', 'LicNm', 'DrvNm'],
            },
          }}
        />
      </Box>
      <FuelDialog 
        selectedId={fuelId}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        fuelMaster={fuelMaster}/>
    </BoxFC>
  );
}
export default FuelReportPeriod